import LastWeekUsers from './LastWeekUsers.js';
import LastWeekPayments from './LastWeekPayments.js';

export const adminCharts = () => {
  new LastWeekUsers();
  new LastWeekPayments();
}



// WEBPACK FOOTER //
// ./resources/assets/js/Charts/AdminCharts.js